export default import.meta.ROLLDOWN_FILE_URL_u4m4LgoGnSNMMzNs726OyA